let scheduleData = [
  {
    day: "Saturday",
    events: [
      {
        name: "Breakfast + Check-in",
        time: "8:30 AM",
        description: "Breakfast will be served from 8:30AM-9:30AM, grab a bite to eat and socialize with other hackers before the opening ceremony!",
      },
      {
        name: "Opening Ceremony",
        time: "9:30 AM",
        description: "Join us at our opening ceremony to learn more about rules, prizes, and events we have planned during ZotHacks 2022!",
      },
      {
        name: "Mentor + Team Meetup",
        time: "9:45 AM",
        description: "Meet the people who you will be working with for the next 12 hours!",
      },
      {
        name: "Hacking begins!",
        time: "10:00 AM",
        description: "It's go time! 😎"
      },
      {
        name: "Design@UCI Workshop",
        time: "10:00 AM",
        description: "Interested in learning more about UI/UX? Design at UCI is hosting a beginner-friendly workshop geared towards hackers— join us to find out how utilizing design principles can set your project apart at ZotHacks and beyond! We’ll be discussing UI and UX design, visual design fundamentals, and user evaluation. Finally, learn how to integrate UI/UX libraries into your code so you can quickly prototype and make your app stand out!",
        link: "https://uci.zoom.us/j/95360078589",
      },
      {
        name: "ICSSC Workshop",
        time: "11:00 AM",
        description: "Want to supercharge your project and impress our judges? Come learn what APIs are and how you can incorporate them into your hack. We’ll walk through examples using the PeterPortal API, a public student-maintained project that provides data on UCI courses, grades, instructors, and much more!",
        link: "https://uci.zoom.us/j/96458579838",
      },
      {
        name: "Lunch",
        time: "1:00 PM",
        description: "Tired of hacking? Refresh your brains and grab some banh mi on the balcony!",
      },
      {
        name: "Kahoot Social",
        time: "3:00 PM",
        description: "Take a break from hacking to play a game of Kahoot about UCI and ICS trivia",
      },
      {
        name: "MAISS Workshop",
        time: "4:00 PM",
        description: "Want to learn how to pitch your idea and make yourself stand out amongst other projects? Then come learn how to do just that! MAISS will be giving you insight on how to present your project to the judges and help you take your idea to the next step!",
        link: "https://uci.zoom.us/j/93853541882",
      },
      {
        name: "Bob Ross Social Event",
        time: "5:00 PM",
        description: "Need some creative energy? Come out to our Bob Ross where you can channel your inner artist and create something fun!",
      },
      {
        name: "Dinner",
        time: "6:00 PM",
        description: "It's the final stretch! But don't forget to take a break and grab dinner ❤️",
      },
      {
        name: "Valorant Social",
        time: "7:30 PM",
        description: "We know there's gamers out there in the crowd 👀 Take a break from staring at code to stare at a game of Valorant 😩",
      },
      {
        name: "Hacking Ends",
        time: "10:00 PM",
        description: "Hooray, you did it! 🥳"
      },
    ],
  },
  {
    day: "Sunday",
    events: [
      {
        name: "Check-in",
        time: "9:30 AM",
        description: "Welcome back to ZotHacks 2022! Come check-in and grab a bite before the project expo!",
      },
      {
        name: "Project Expo",
        time: "10:30 AM",
        description: "Congratulations on finishing ZotHacks 2022! We're so excited to see all of your project submissions, so make sure to come to DBH 6011 for our project expo where you can look at other teams' projects!"
      },
      {
        name: "Closing Ceremony",
        time: "12:30 PM",
        description: "Come out to our closing ceremony for our final wrap-up of ZotHacks 2022! Find out if your team came out on top and celebrate everyone's hard work over the weekend ❤️",
      }
    ],
  },
]

export { scheduleData }
